const UserIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.06 5.94a9 9 0 1 1-12.12 0 9 9 0 0 1 12.12 0Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.81 17.74C7.55 15.96 9.44 14.86 12.03 14.86c2.56 0 4.42 1.08 6.16 2.83-1.74 1.79-3.63 2.89-6.21 2.89-2.56 0-4.42-1.08-6.16-2.83Z"
      fill="white"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.02 7.12a3 3 0 1 1-4.04 0 3 3 0 0 1 4.04 0Z"
      fill="white"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserIcon;
